// extracted by mini-css-extract-plugin
export var closeButton = "_c0-1";
export var closeX = "_c0-3";
export var container = "_c0-0";
export var image = "_c0-2";